import React from 'react'

import { Image } from '@gousto-internal/citrus-react'

import carouselimage from '../../../../sections/assets/carouselimage.jpg'

export const bannerImageSectionAltText =
  'A range of Gousto recipes for every preference: Family Friendly, Veg Boost, Protein Hit and more.'

export function BannerImageSection() {
  return (
    <Image
      fit="cover"
      height={['120px', '141px', null, '160px']}
      alt={bannerImageSectionAltText}
      src={carouselimage}
    />
  )
}
